import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

import { routeToPage } from 'support/helpers/navigation/navigation';
import { OrderFormsRoutes } from 'support/types';

import { Button } from 'components/Form/Button';

export function BackButton({ supplierSlug, disabled }: { supplierSlug: string; disabled: boolean }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Button
      variant="minimal"
      analyticsId="order-form-checkout-back"
      LeftIcon={ArrowLeftIcon}
      onClick={() => navigate(routeToPage(OrderFormsRoutes.root, { supplierSlug }))}
      disabled={disabled}
    >
      {t('common:back')}
    </Button>
  );
}
